<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        <div id="row1" class="row">
            <div class="col col-12">
                <h1>request dashboard</h1>
                <div style="text-align: center;">
                    <a class="arrow-link" [routerLink]="['/requests/dashboards/by-type']">request by type</a>
                    <span style="padding-left: 50px;"></span>
                    <a class="arrow-link" [routerLink]="['/requests/dashboards/by-status']">request by status</a>
                </div>

                <by-request-type style="width: 100%; height: 100%" [barColor]="allRequestsBarColor"
                    [requestType]="allRequestType" [useWorkflowRequests]="true" [workflowRequests]="allWorkflowRequests"
                    [allowRequestTypeChange]="false" [numberOfMonths]="numberOfMonths"></by-request-type>
            </div>
        </div>
    </section>
</main>